module.exports = __webpack_public_path__ + "static/media/messages-2.4394e68b.svg";